import httpClient from '../lib/httpClient';

// CMS API endpoints
const CMS_BASE_URL = '/cms';

// Types for CMS data
export interface Genre {

  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface Trope {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

// Fetch available genres
const fetchAvailableGenres = async (): Promise<Genre[] | null> => {
  try {
    console.log('Fetching genres from:', `${CMS_BASE_URL}/genre`);
    const response = await httpClient.get(`${CMS_BASE_URL}/genre`);
    return Array.isArray(response) ? response : [];
  } catch (error) {
    console.error('Error fetching available genres:', error);
    return null;
  }
};

// Fetch available tropes
const fetchAvailableTropes = async (): Promise<Trope[] | null> => {
  try {
    const response = await httpClient.get(`${CMS_BASE_URL}/trope`);
    return Array.isArray(response) ? response : [];
  } catch (error) {
    console.error('Error fetching available tropes:', error);
    return null;
  }
};

export { fetchAvailableGenres, fetchAvailableTropes };

export const cmsService = {
  fetchAvailableGenres,
  fetchAvailableTropes
};